import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Form } from 'react-final-form'
import AttentionHours from './AttentionHours'
import Alert from '../../molecules/Alert'
import { Button } from '../../atoms/Button'
import ReceptionDeskAdditionalConfig from './ReceptionDeskAdditionalConfig'
import EditCancelButton from '../../molecules/buttons/EditCancelButton'
import ToastAlert from '../../molecules/ToastAlert'
import { defaultHours } from '../../../configs/officeHourConfig'

const OfficeHoursReceptionDeskForm = ({ initialValues, onSubmit }) => {
  const [editMode, setEditMode] = useState(false)
  const [saveCompleted, setSaveCompleted] = useState(false)
  const [alertText, setAlertText] = useState('Cambios guardados exitosamente.')
  const [alertStatus, setAlertStatus] = useState('success')

  const handleSubmit = async values => {
    try {
      await onSubmit(values)
      setEditMode(false)
      setAlertText('Cambios guardados exitosamente.')
      setAlertStatus('success')
      setSaveCompleted(true)
    } catch (error) {
      setAlertText('Ocurrió un error al guardar los cambios.')
      setAlertStatus('error')
      setSaveCompleted(true)
    }
  }

  const handleEdit = form => {
    if (editMode) {
      handleCancel(form)
    } else {
      setEditMode(true)
    }
  }

  const handleCancel = form => {
    setEditMode(false)
    form.reset()
  }

  return (
    <div className="p-10 bg-neutral-100 rounded-2.5xl">
      <Form
        onSubmit={handleSubmit}
        initialValues={initialValues}
        subscription={{ submitting: true, pristine: true }}
        autoComplete="off"
      >
        {({ handleSubmit, submitting, pristine, form }) => (
          <>
            <div className="flex flex-col-reverse md:flex-row justify-between mb-6">
              <h2 className="text-xl font-bold">Horario de atención de la Mesa de partes (obligatorio)</h2>
              <EditCancelButton
                onClick={() => handleEdit(form)}
                editMode={editMode}
                className="self-end md:self-center mb-6 md:mb-0 font-bold"
              />
            </div>
            <p>Valida o modifica el horario de atención para tus formularios de Mesa de partes.</p>
            <form onSubmit={handleSubmit}>
              <div className="flex flex-col md:flex-row w-full gap-4 my-6">
                <div className="md:w-1/2">
                  <AttentionHours
                    enabled={editMode}
                    startName={'reception_desk_start_office_hour'}
                    endName={'reception_desk_end_office_hour'}
                    initialStartHour={defaultHours.receptionDeskMinStartHour}
                    initialEndHour={defaultHours.receptionDeskMaxStartHour}
                    minRangeDifference={8}
                    required
                  />
                </div>
                <div className="md:w-1/2">
                  <Alert type="info" border>
                    <ul className="list-outside list-disc ml-4">
                      <li>
                        El horario de atención debe ser continuo y de un mínimo de 8 horas, conforme al artículo 149 de
                        la Ley N.º 27444, y debes derivar internamente la solicitud al área competente el mismo día
                        hábil en que se reciba a través de la mesa de partes digital.
                      </li>
                      <li>
                        Esto no restringe el derecho del ciudadano a presentar solicitudes las 24 horas del día, los 7
                        días de la semana, ni modifica la fecha y hora legal del registro.
                      </li>
                    </ul>
                  </Alert>
                </div>
              </div>
              <div>
                <ReceptionDeskAdditionalConfig enabled={editMode} />
              </div>
              {editMode && (
                <div className="flex flex-col-reverse md:flex-row justify-end gap-4 text-lg">
                  <Button
                    variant="text"
                    size="full"
                    type="button"
                    className="block py-3 md:max-w-56"
                    disabled={submitting || pristine}
                    onClick={() => handleCancel(form)}
                  >
                    Cancelar
                  </Button>
                  <Button
                    size="full"
                    type="submit"
                    className="block py-3 md:max-w-56"
                    disabled={submitting || pristine}
                  >
                    Guardar
                  </Button>
                </div>
              )}
            </form>
          </>
        )}
      </Form>
      <ToastAlert
        alertText={alertText}
        type={alertStatus}
        open={saveCompleted}
        onClose={() => setSaveCompleted(false)}
      />
    </div>
  )
}

export default OfficeHoursReceptionDeskForm

OfficeHoursReceptionDeskForm.propTypes = {
  initialValues: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired
}
